import actionTypes from './actions/actionTypes'
import moment from 'moment'

const {
  PLAN_DETAILS,
} = actionTypes

const planReducer = (state = {
  companyName: 'なし',
  concurrency: 10,
  expirationDate: moment('2018-09-01 00:00:00').format('YYYY-MM-DD'),
  recordStorage: '0GB',
  currentAccount: '',
  domainUrlName: '',
  status: '',
  max_room_num_per_user: '',
  contractStatus: '一時トライアル(有効)'
}, action) => {
  switch (action.type) {
    case PLAN_DETAILS:
      return Object.assign({}, state, {
        ...action.data
      })
    default:
      return state
  }
}

export default planReducer



// WEBPACK FOOTER //
// ./src/components/PlanDetails/reducer.js